// When passing through a task instance, the type of the value is not needed to be known.

export function* waitForOperation(operation, id) {
  const result = yield operation.waitFor(id);
  if (result.error) {
    const err = result.error;
    throw new Error(err.message ?? 'Unknown error');
  }
  return result;
}